
                import "css-modules://src_components_contact"
                export default {"Main":"_2d9bd7","Inner":"_2fd8a2","Title":"_625a8a","Content":"_e0aceb","Address":"_3ab953","Contact":"_f64d44"}
            